<template>
  <div class="the-header-line">
    <div class="the-header-line__inner container">
      <div class="d-flex align-center justify-center">
        <button
          type="button"
          class="the-header-line__hamburger-btn ui-icon-menu pr-3 py-1"
          aria-hidden="false"
          data-role="none"
          data-qa="the_header_hamburger_btn"
          @click="handleClickHamburger"
        />
        <a
          href="/"
          class="d-flex"
          data-qa="the_header_logo_link"
        >
          <img
            class="the-header-line__logo"
            :class="{ 'the-header-line__logo--event': showEventSiteLogo }"
            :src="siteLogo.src"
            :alt="siteLogo.alt"
          >
        </a>
      </div>

      <HeaderAnalyses />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  toRefs,
  type Ref,
} from 'vue'
import { getSiteLogoPd, type SiteLogo } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/constants'
import { HeaderAnalyses } from 'src/layouts/core-layout/components/CoreHeader/components'

type UserInfo = {
  isRealPatient?: boolean
  isAnonymous?: boolean
  isDoctor?: boolean
}

const appWindow = (typeof window !== 'undefined' ? window : {}) as Window & {
  SITE_SETTINGS?: { show_event_site_logo?: boolean }
  USER?: UserInfo
}

const props = withDefaults(defineProps<{
  siteLogo?: SiteLogo
  withoutAnalysesCart?: boolean
  analysesCountInCart?: number
}>(), {
  siteLogo: () => getSiteLogoPd(),
  withoutAnalysesCart: false,
  analysesCountInCart: 0,
})

const emit = defineEmits<{(_event: 'header:click-hamburger-btn'): void
}>()

const { siteLogo } = toRefs(props)

const showEventSiteLogo: Ref<boolean> = ref(Boolean(appWindow.SITE_SETTINGS?.show_event_site_logo))

function handleClickHamburger() {
  emit('header:click-hamburger-btn')
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.the-header-line {
  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__hamburger-btn {
    border: none;
    background-color: transparent;
  }

  &__logo {
    object-fit: contain;
    width: 184px;
    height: 28px;

    &--event {
      width: 240px;
      height: 28px;
    }
  }

  &__search-btn-empty {
    position: relative;
    width: 48px;
  }
}

:deep(.add-point-to-cart) {
  position: absolute;
  min-height: 14px;
  bottom: 17px;
  left: 10px;
  padding: 2px 7px;
  color: $ui-kit-bg-gray-0;
  background-color: red;
  border-radius: 10px;
}

:deep(.cart-icon) {
  height: 24px;
  position: relative;
  margin-right: 16px;

  @media screen and (max-width: 350px) {
    margin-right: 0;
  }
}
</style>
